import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';

var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"error-bar animated slideInDown"},[_c(VContainer,[_c(VRow,[_c(VCol,{attrs:{"cols":"12","xs":"12"}},[_c('p',{staticClass:"error-message pt-2"},[_c(VIcon,{staticClass:"icon"},[_vm._v("fa-exclamation-triangle")]),_vm._v(" "+_vm._s(_vm.errorText))],1)])],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }